import { AccountCircle, AccountTree } from "@mui/icons-material";
import Dashboard from "@mui/icons-material/Dashboard";
import HomeIcon from '@mui/icons-material/Home';
import EventRepeatSharpIcon from "@mui/icons-material/EventRepeatSharp";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CategoryIcon from '@mui/icons-material/Category';
import BedroomParentIcon from '@mui/icons-material/BedroomParent';
import AssistantIcon from '@mui/icons-material/Assistant';
import { Person } from "@mui/icons-material";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { ACTMGMT, BANQUETBOOKING, CUSTOMERMGMT, EMPMGMT, HOTELBKNG, REPGEN } from "../../constants/Permissions";

export const sidebardata = [
  {
    title: "Home",
    path: "/home",
    checkAdminRules: "allow",
    icon: <HomeIcon />,
  },
  {
    title: "Owner Dashboard",
    path: "/dashboard",
    checkAdminRules: "allow",
    icon: <Dashboard />,
  },
  {
    title: "Report Management",
    path: "/report",
    checkAdminRules: REPGEN,
    icon: <SummarizeIcon />,
  },
  {
    title: "Maintain Employee",
    path: "/employee",
    checkAdminRules: EMPMGMT,
    icon: <AccountCircle />,
  },
  {
    title: "Room Definition",
    path: "/",
    checkAdminRules: "allow",
    icon: <AssistantIcon />,
    items: [
      {
        title: "Cateogory",
        path: "/cateogory",
        checkAdminRules: "allow",
        icon: <CategoryIcon />,
      },
      {
        title: "Create Room",
        path: "/createroom",
        checkAdminRules: "allow",
        icon: <MeetingRoomIcon />,
      }
    ]
  },
  {
    title: "Check Bookings",
    path: "/",
    checkAdminRules: "allow",
    icon: <EventRepeatSharpIcon />,
    items: [
      {
        title: "Book Room",
        path: "/bookroom",
        checkAdminRules: HOTELBKNG,
        icon: <BedroomParentIcon />,
      },
      {
        title: "Book Banquet",
        path: "/bookbanquet",
        checkAdminRules: BANQUETBOOKING,
        icon: <BedroomParentIcon />,
      },
      {
        title: "Show All Bookings",
        path: "/showbookings",
        checkAdminRules: "allow",
        icon: <FormatListBulletedIcon />,
      }
    ]
  },
  {
    title: "Show Customer",
    path: "/customer",
    checkAdminRules: CUSTOMERMGMT,
    icon: <Person />,
  },
  {
    title: "Profile & Configuration",
    path: "/profile",
    checkAdminRules: "allow",
    icon: <AccountBoxIcon />,
  },
  {
    title: "Show Accounting",
    path: "/accounting",
    checkAdminRules: ACTMGMT,
    icon: <AccountTree />,
  },
];
